//this can be extended as page context store in future, using it only for retry for now
import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { produce } from 'immer';

interface PageContextState {
  resultsRetried: boolean;
}

interface PageContextActions {
  updatePageContextVar: (key: string, value: boolean) => void;
}

const initialState: PageContextState = {
  resultsRetried: false,
};

export const pageCOntextStore: StateCreator<PageContextState & PageContextActions> = set => {
  return {
    ...initialState,
    updatePageContextVar: (key: string, value: boolean) => {
      set(produce(draft => void (draft[key] = value)));
    },
  };
};

export const usePageContextStore = createAppStore(pageCOntextStore, {
  usePersistentStore: false,
});
